import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      label: 'GDPR Compliant',
      description: 'Data protection'
    },
    {
      icon: 'CheckCircle',
      label: 'SOC 2 Certified',
      description: 'Security audited'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="text-center mb-4">
        <p className="text-xs text-muted-foreground font-medium">
          Trusted by 500+ companies worldwide
        </p>
      </div>
      <div className="grid grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="text-center">
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-2">
              <Icon name={feature?.icon} size={14} className="text-success" />
            </div>
            <p className="text-xs font-medium text-foreground">{feature?.label}</p>
            <p className="text-xs text-muted-foreground">{feature?.description}</p>
          </div>
        ))}
      </div>
      <div className="text-center mt-6">
        <p className="text-xs text-muted-foreground">
          © {new Date()?.getFullYear()} HR Portal Pro. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;